export default function (value) {
    return value.substring(0, 83) + "..."
}
